module.exports = __webpack_public_path__ + "img/befunde.81bd63d5.svg";